export default "__VITE_ASSET__CA0o7IVK__"